import React, { useState } from "react";
import { CustomerCreate, LocationCreate, DepartmentCreate, CustomerPrices } from "./";

const CustomerCreateForm = () => {
  const [formStep, setFormstep] = useState(0);
  const [customerId, setCustomerId] = useState();
  const [locationId, setLocationId] = useState();
  const stepTitle = {
    0: "Nieuwe klant aanmaken",
    1: "Locatie koppelen aan klant",
    2: "Afdeling koppelen aan locatie",
    3: "Maaltijdprijzen voor deze klant",
  };

  const _next = () => {
    if (formStep < 3) {
      setFormstep(formStep + 1);
    } else {
      console.log("return to customer overview");
    }
  };
  // TODO: Make links clickable when customer_id and location_id are known.
  return (
    <div className="container">
      <h2 className="container__title">{stepTitle[formStep]}</h2>
      <div className="form__container">
        <div className="form__container__tabs">
          <span className="form__container__tabs__step">
            Stap1. Zorginstelling
          </span>
          <span className="form__container__tabs__step">
            Stap2. Locatiegegevens
          </span>
          <span className="form__container__tabs__step">
            Stap3. Afdelingsgegevens
          </span>
          <span className="form__container__tabs__step">
            Stap4. Calculatie gegevens
          </span>
        </div>
        {formStep === 0 && (
          <CustomerCreate next={_next} setCustomerId={setCustomerId} />
        )}
        {formStep === 1 && (
          <LocationCreate
            next={_next}
            customerId={customerId}
            setLocationId={setLocationId}
          />
        )}
        {formStep === 2 && (
          <DepartmentCreate next={_next} customerId={customerId} />
        )}
        {formStep === 3 && (
          <CustomerPrices next={_next} customerId={customerId} />
        )}
      </div>
    </div>
  );
};

export default CustomerCreateForm;
